import React from 'react';
import './Footer.css'; // Optional: Add styles for the footer

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                
                <ul className="footer-links">
                    <li><a href="/about">About</a></li>
                    <li><a href="/contact">Contact</a></li>
                    <li><a href="/privacy">Privacy Policy</a></li>
                </ul>
                <p>&copy; {new Date().getFullYear()} digitaljournaling.com All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;